import * as Sentry from '@sentry/vue'

async function lazyLoadSentryIntegrations () {
  // don't load on server
  if (!import.meta.client) { return }

  const { Replay } = await import('@sentry/vue')
  Sentry.addIntegration(new Replay({
    maskAllText: false,
    blockAllMedia: false
  }))
}

function getSentryIntegrations () {
  // don't load on server
  if (!import.meta.client) { return [] }

  const router = useRouter()
  const browserTracing = new Sentry.BrowserTracing({
    routingInstrumentation: Sentry.vueRouterInstrumentation(router)
  })

  return [browserTracing]
}

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  async setup (nuxtApp) {
    const vueApp = nuxtApp.vueApp
    Sentry.init({
      enabled: process.env.NODE_ENV !== 'development',
      release: 'classroom-laoshi@' + nuxtApp.$config.public.packageVersion,
      app: nuxtApp.vueApp,
      dsn: 'https://9014f9451d5cf8d60bb8003daa4b1615@o4506615133372416.ingest.us.sentry.io/4506660261330944',
      tracePropagationTargets: ['localhost', /^https:\/\/cabinet.laoshi\.io\/v1.1/],
      integrations: getSentryIntegrations(),

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // This sets the sample rate. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.2,

      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1.0
    })

    // Lazy-load the replay integration to reduce bundle size
    lazyLoadSentryIntegrations()
  }
})
